export default __webpack_public_path__ + "static/media/warn-blue.a42ef30f.svg";